import React, { useState, useEffect, useRef } from 'react';
import apiClient from '../apiClient';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useShop } from '../context/ShopContext';
import { FaSpinner } from 'react-icons/fa';
import Sidebar from './Sidebar';
import EmptyState from "./EmptyState";
import "./responsiveTable.css";

const Expensedate = () => {
  const [expenses, setExpenses] = useState([]); // State to store expenses list
  const [amounts, setAmounts] = useState({}); // State to store amount for each expense
  const [remarks, setRemarks] = useState({}); // State to store remark for each expense
  const inputRefs = useRef([]); // References for all inputs
  const [amount, setAmount] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false); // State to track OTP verification
  const [error, setError] = useState('');
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const { shopName, shopId, userId, companyId } = useShop(); // Destructure shopName from context
  const [otpId, setOtpId] = useState(null); // State to store otpId
   const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
 
  const [isSendingOtp, setIsSendingOtp] = useState(false); // State for SEND OTP button
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false); // State for Verify OTP button
   const [isSubmitting, setIsSubmitting] = useState(false); // Add state for submit button
    const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  // Per-head validation state: { [expenseId]: { amount?: true, remark?: true } }
  const [fieldErrors, setFieldErrors] = useState({});








         const showToast = (message, type = "error") => {
              toast.dismiss(); // Dismiss any existing toast before showing a new one
            
              console.log("Toast Type:", type); // Debugging log to check type value
            
              if (type.toLowerCase() === "error") {
                toast.error(message);
              } else if (type.toLowerCase() === "success") {
                toast.success(message);
              } else {
                console.warn("Invalid toast type:", type);
              }
            };



useEffect(() => {
    const fetchExpenses = async () => {
      try {
        setLoading(true); // Start loader before API call
        const response = await apiClient.post(
          '/Liquor/GetExpenseMaster',
          { companyId }
        );
        setExpenses(response.data?.data || []);
      } catch (err) {
        console.error('Error fetching expenses:', err);
        showToast('Failed to load expenses.',"error");
      } finally {
        setLoading(false); // Stop loader after API call completes
      }
    };
    fetchExpenses();
  }, []);
   
   
   
        // Set default from date to today's date on initial render
        useEffect(() => {
         const today = new Date();
         const isoDate = today.toISOString().split("T")[0]; 
         setDate(isoDate); 
       }, []);

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        const response = await apiClient.post(
          '/Liquor/GetExpenseMaster',
          { companyId }
        );
        setExpenses(response.data?.data || []);
      } catch (err) {
        console.error('Error fetching expenses:', err);
        showToast('Failed to load expenses.',"error");
      }
    };
    fetchExpenses();
  }, []);






  const handleInputChange = (id, field, value) => {
    if (field === 'amount') {
      if (value < 0) {
        showToast('Amount cannot be negative',"error");
        return;
      }
      setAmounts((prev) => ({ ...prev, [id]: value }));
    } else if (field === 'remark') {
      setRemarks((prev) => ({ ...prev, [id]: value }));
    }

    // Clear this box's complaint as soon as the user starts fixing it.
    setFieldErrors((prev) => {
      if (!prev[id] || !prev[id][field]) return prev;
      const next = { ...prev, [id]: { ...prev[id] } };
      delete next[id][field];
      if (Object.keys(next[id]).length === 0) delete next[id];
      return next;
    });
  };

  const isBlank = (v) => String(v ?? '').trim() === '';

  /*  A row counts as started the moment either box has something in it, and a
      started row needs both: TrnExpense.Remark is NOT NULL, and an amount with
      no remark is unidentifiable in the expense report.

      Submit used to filter on `amount > 0 && remark` and keep only what passed,
      so a half-filled row was thrown away silently - and if some other row
      happened to be complete, the save still reported success while the
      half-filled one vanished.  */
  const collectRows = () => {
    const started = expenses.filter(
      (e) => !isBlank(amounts[e.id]) || !isBlank(remarks[e.id])
    );

    const errors = {};
    started.forEach((e) => {
      const bad = {};
      if (!(parseFloat(amounts[e.id]) > 0)) bad.amount = true;
      if (isBlank(remarks[e.id])) bad.remark = true;
      if (bad.amount || bad.remark) errors[e.id] = bad;
    });

    return { started, errors };
  };
  


  

  const handleKeyDown = (index, field, event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      const nextIndex = field === 'amount' ? index * 2 + 1 : index * 2 + 2;
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }
  };



  const handleSendOtp = async () => {
    // Validate that amount is positive and not empty
   
    setIsSendingOtp(true);
    try {
      const requestBody = {
        userId: userId,
        shopName: shopName,
        otp: '',
        amount: parseFloat(amount),
      };
  
      const response = await apiClient.post(
        '/Liquor/SendExpenseOTP',
        requestBody
      );
  
      if (response.data.code === 200) {
        setOtpSent(true);
        setOtpId(response.data.data.id);
        showToast('OTP sent successfully!',"success");
      } else {
        toast.error(response.data.message || 'Failed to send OTP.');
      }
    } catch (err) {
      console.error('Error sending OTP:', err);
      showToast('An error occurred while sending OTP.',"error");
    } finally {
      setIsSendingOtp(false);
    }
  };
  

  // Handle OTP Verification
  const handleVerifyOtp = async () => {
    if (!otp) {
      setError('Please enter the OTP.');
      return;
    }

    setIsVerifyingOtp(true); // Disable Verify OTP button
    try {
      const requestBody = {
        otpId: otpId,
        otp: otp,
        userId: userId,
      };

      const response = await apiClient.post(
        '/Liquor/VerifyExpenseOTP',
        requestBody
      );

      if (response.data.code === 200) {
        setIsOtpVerified(true); // Mark OTP as verified
        showToast('Verified OTP successfully',"success");
      } else {
        showToast('Failed to verify OTP.',"error");
        setIsVerifyingOtp(false); // Re-enable Verify OTP button on failure
      }
    } catch (err) {
      console.error('Error verifying OTP:', err);
      showToast('An error occurred while verifying OTP.',"error");
      setIsVerifyingOtp(false); // Re-enable Verify OTP button on error
    }
  };

  // Handle Expense Submission
  const handleSubmit = async () => {
    const { started, errors } = collectRows();
    setFieldErrors(errors);

    if (started.length === 0) {
      showToast('Enter an amount and a remark for at least one expense.',"error");
      return;
    }

    // Every started row is reported by name, rather than being dropped.
    const incomplete = started.filter((e) => errors[e.id]);
    if (incomplete.length > 0) {
      const detail = incomplete
        .map((e) => {
          const missing = [];
          if (errors[e.id].amount) missing.push('amount');
          if (errors[e.id].remark) missing.push('remark');
          return `${e.expName} (${missing.join(' and ')})`;
        })
        .join(', ');
      showToast(`Missing ${detail}.`,"error");
      return;
    }

    const requestBody = started.map((expense) => ({
      shopId: shopId,
      expenseId: expense.id, // Use the correct expenseId
      expenseAmount: parseFloat(amounts[expense.id]), // Use the amount from the amounts state
      userId: userId,
      Remark: String(remarks[expense.id]).trim(), // Use the remark from the remarks state
      expenseDate: date || new Date().toISOString().split("T")[0], // Ensure valid date format
    }));
    console.log("requestexpense:",requestBody)

    setIsSubmitting(true); // Disable Submit button
  
    try {
      // Make the POST request to save expenses
      const response = await apiClient.post(
        '/Liquor/SaveExpenseWithDate',
        requestBody
      );
  
      console.log('SaveExpenses', response);
  
      // Handle the API response
      if (response.data && response.data.code === 200) {
        showToast('Expenses saved successfully!',"success");
        setAmount('');
        setOtp('');
        setAmounts({});
        setRemarks({});
        setFieldErrors({});
        setIsOtpVerified(false);
        setOtpSent(false);
      } else {
        showToast(response.data.message || 'Failed to save expenses.',"error");
      }
    } catch (err) {
      console.error('Error saving expenses:', err);
      showToast('An error occurred while saving the expense.',"success");
      setIsSubmitting(false); // Re-enable Submit button
    }
  };

















 const handleDateChange = (e) => {
  const newDate = e.target.value;
  setDate(newDate);
 
};
  

  /*  The OTP is requested before the rows are saved, so the rows have to be
      complete by then. Gating on the amount alone let a user verify an OTP for
      a form that submit would then refuse.  */
  const { started: startedRows, errors: rowErrors } = collectRows();
  const canSendOtp = startedRows.length > 0 && Object.keys(rowErrors).length === 0;
  return (
    
    
      <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
        {/* Content wrapper */}
        <div className="d-flex flex-column flex-column-fluid">
            {/* Toolbar */}
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                {/* Toolbar container */}
                <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                    {/* Page title */}
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        {/* Title */}
                        <h1 className="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center my-0">
                        Enter Expense
                        </h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <a href="index.html" className="text-muted text-hover-primary">Home</a>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-500 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Dashboards</li>
                        </ul>
                    </div>
                </div>
            </div>
      
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-fluid">
                    <div className="row g-5 g-xl-10 mb-5 mb-xl-10">
                        <div className="col-xl-12">
                            <div className="card card-flush h-md-100">
                                <ToastContainer />
                              
                                <div className="card-body pt-6">
                                    <div className="table-responsive">
                                        <div className="panel-body">
                                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                                <div className="form-group d-flex gap-5 flex-wrap">
                                                  <div>
                                                    <label className="form-label">Date:</label>
                                                    <input
                                                      type="date"
                                                      className="form-control"
                                                      value={date}
                                                      max={new Date().toISOString().split("T")[0]}
                                                      onChange={handleDateChange}
                                                    />
                                                  </div>
                                                  <div>
                                                    <label className="form-label">Search Expense:</label>
                                                    <input
                                                      type="text"
                                                      className="form-control"
                                                      placeholder="Search expense..."
                                                      value={searchQuery}
                                                      onChange={(e) => setSearchQuery(e.target.value)}
                                                    />
                                                  </div>
                                                </div>
                                            </div>
                                            <div className="clearfix"></div>
                                            <br />
   
          <div className="table-responsive h-700px entry-desktop" style={{ WebkitOverflowScrolling: "touch" }}>
          {loading ? (
                                            <div className="loader-container">
                                                <FaSpinner className="spinner-icon" />
                                            </div>
                                        ) : expenses.length > 0 ? (
       <table className="table table-bordered table-striped">
  <thead>
  <tr>
  <th>S.No.</th>
  <th>Expense</th>
  <th>Amount</th>
  <th>Remark</th>
  </tr>
  </thead>
  <tbody>
  {expenses.filter(e => e.expName.toLowerCase().includes(searchQuery.toLowerCase())).map((expense, index) => (
  <tr key={expense.id}>
  <td>{index + 1}</td>
  <td>{expense.expName}</td>
  <td>
  <input
  type="text"
  className={`form-control ${fieldErrors[expense.id]?.amount ? 'is-invalid' : ''}`}
  value={amounts[expense.id] || ''}
  ref={(el) => (inputRefs.current[index * 2] = el)} // Reference for Amount input
  onChange={(e) => {
  const value = e.target.value;
  if (value === '' || Number(value) > 0) {
  handleInputChange(expense.id, 'amount', value);
  } else {
  showToast("Amount must be greater than 0!", "error");
  }
  }}
  onKeyDown={(e) => {
  // Prevent e, E, +, -, .
  if (["e", "E", "+", "-", "."].includes(e.key)) {
  e.preventDefault();
  } else {
  handleKeyDown(index, 'amount', e);
  }
  }}
  placeholder="Enter Amount"
  min="1"
  />
  
  </td>
  <td>
    <input
      type="text"
      className={`form-control ${fieldErrors[expense.id]?.remark ? 'is-invalid' : ''}`}
      value={remarks[expense.id] || ''}
      ref={(el) => (inputRefs.current[index * 2 + 1] = el)}
      onChange={(e) => handleInputChange(expense.id, 'remark', e.target.value)}
      onKeyDown={(e) => handleKeyDown(index, 'remark', e)}
      placeholder="Enter Remark"
    />
  </td>
  </tr>
  ))}
  </tbody>
  </table>
  ) : (
  <EmptyState />
  )}
  </div>

                                          {/* Mobile: expense cards */}
                                          <div className="entry-mobile">
                                            {loading ? (
                                              <div className="loader-container"><FaSpinner className="spinner-icon" /></div>
                                            ) : expenses.length === 0 ? (
                                              <EmptyState />
                                            ) : (
                                              expenses.filter(e => e.expName.toLowerCase().includes(searchQuery.toLowerCase())).map((expense, index) => (
                                                <div key={expense.id} className="ef-card">
                                                  <div className="ef-card-header">
                                                    <span className="ef-card-title">{expense.expName}</span>
                                                    <span className="ef-card-badge">#{index + 1}</span>
                                                  </div>
                                                  <div className="ef-card-body">
                                                    <div className="ef-field">
                                                      <span className="ef-field-label">Amount</span>
                                                      <input
                                                        type="text"
                                                        className={`form-control ${fieldErrors[expense.id]?.amount ? 'is-invalid' : ''}`}
                                                        value={amounts[expense.id] || ''}
                                                        onChange={(e) => {
                                                          const value = e.target.value;
                                                          if (value === '' || Number(value) > 0) {
                                                            handleInputChange(expense.id, 'amount', value);
                                                          } else {
                                                            showToast("Amount must be greater than 0!", "error");
                                                          }
                                                        }}
                                                        onKeyDown={(e) => {
                                                          if (["e", "E", "+", "-", "."].includes(e.key)) e.preventDefault();
                                                        }}
                                                        placeholder="Enter Amount"
                                                        min="1"
                                                      />
                                                    </div>
                                                    <div className="ef-field">
                                                      <span className="ef-field-label">Remark</span>
                                                      <input
                                                        type="text"
                                                        className={`form-control ${fieldErrors[expense.id]?.remark ? 'is-invalid' : ''}`}
                                                        value={remarks[expense.id] || ''}
                                                        onChange={(e) => handleInputChange(expense.id, 'remark', e.target.value)}
                                                        placeholder="Enter Remark"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              ))
                                            )}
                                          </div>

                                              <div class="text-right align-items-right d-flex justify-content-end">


                                              <button
  type="button"
  className="btn btn-info"
  onClick={handleSendOtp}
  disabled={isSendingOtp || otpSent || !canSendOtp}
>
  SEND OTP
</button>
  </div>
  
                              {/* OTP Input */}
                              {otpSent && ( // Conditionally render the OTP input if otpSent is true
    <div className="form-group text-left">
      <input
        type="text"
        className="form-control"
        id="otp"
        placeholder="Enter OTP"
        value={otp}
        onChange={(e) => setOtp(e.target.value)}
      />
    </div>
  )}
                             {otpSent && !isOtpVerified && ( // Conditionally render the OTP verification button if otpSent is true and OTP is not verified
    <div className="form-group">
      <button
        type="button"
        className="btn btn-success"
        onClick={handleVerifyOtp}
        disabled={isVerifyingOtp} // Disable while verifying
      >
        Verify OTP
      </button>
    </div>
  )}
  
                           
                              {/* Submit Button */}
                              {isOtpVerified && ( // Conditionally render the Submit button if OTP is verified
    <div className="form-group">
       <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleSubmit}
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? <FaSpinner className="spinner" /> : 'SUBMIT'}
                            </button>
    </div>
  )}
     
    
    
                                              
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      
        {/* Footer */}
        <div id="kt_app_footer" className="app-footer">
            <div className="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3">
                <div className="text-gray-900 order-2 order-md-1">
                    <span className="text-muted fw-semibold me-1">2025&copy;</span>
                    <a href="#" target="_blank" className="text-gray-800 text-hover-primary">WineShop</a>
                </div>
            </div>
        </div>
    
      
      
      
      
      
      
      
  
      
     
      
      
      
      
      
     
      
    
      
      </div>
     

   
  );
};

export default Expensedate;
